<template>
  <div>
    <div class="animated fadeIn">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    </div>
    <b-card header-tag="header">
      <template slot="header">
        <b-row>
          <b-col cols="12">
            <h3 class="float-left">
              <strong>Cardapio</strong>
            </h3>
            <b-button
              class="float-right"
              variant="success"
              @click="save"
              :disabled="!saveBtn"
            >Salvar</b-button>
            <b-button
              class="float-right mr-3"
              variant="primary"
              @click="redirecionar"
            >Criar campanha</b-button>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col xl="6" lg="6" md="6" sm="12">
          <picture-input
            ref="pictureInput"
            margin="16"
            width="300"
            height="400"
            accept="image/jpeg, image/png"
            :autoToggleAspectRatio="true"
            :removable="true"
            size="10"
            :zIndex="10"
            button-class="changeBtn"
            removeButtonClass="removeBtn"
            v-bind:prefill="prefill"
            :custom-strings="{
              upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
              drag: 'Arraste uma imagem <br> (ou clique aqui)',
              change: 'Mudar foto',
              remove: 'Remover foto'
            }"
            @change="onChange"
          ></picture-input>
        </b-col>
        <b-col xl="6" lg="6" md="6" sm="12">
          <b-input-group prepend="Data Validade" class="date-input mt-3 auto-prepend">
            <datepicker
              class="form-control"
              placeholder="Escolha a data"
              v-model="validade"
              :language="ptBR"
              :format="customFormatter"
              :disabled-dates="{ to: new Date(moment().subtract(1, 'days')) }"
              @input="onChangeDate"
            ></datepicker>
          </b-input-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import PictureInput from "vue-picture-input";
import axios from "axios";
import * as config from "@/config.json";
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
import Loading from "vue-loading-overlay";

import moment from "moment";

export default {
  name: "Cardapio",
  components: {
    PictureInput,
    moment,
    Datepicker,
    Loading
  },
  data: _ => {
    return {
      saveBtn: false,
      imageSource: null,
      prefill: null,
      validade: null,
      ptBR: ptBR,
      isLoading: false
    };
  },

  async beforeMount() {
    this.isLoading = true;
    await this.receberCardapio();

    this.isLoading = false;
  },

  methods: {
    onChange(image) {
      if (image) {
        this.saveBtn = true;
        this.imageSource = image;
      }
    },
    onChangeDate() {
      this.saveBtn = true;
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    goBack() {
      localStorage.removeItem("image");
      localStorage.removeItem("url_imagem");
      localStorage.removeItem("validade");
      this.$router.go(-1);
    },
    verificaCampos() {
      if (this.validade == null || this.validade == "") return false;
      return true;
    },
    async receberCardapio() {
      await axios
        .get(
          `${config.default.servidor}/gerencial/cardapio/${localStorage.getItem(
            "enterprise_id"
          )}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(async response => {
          if (response.status == 200) {
            this.prefill = response.data.url
              ? moment(response.data.data).isSameOrAfter(new Date())
                ? `https://cors-anywhere.herokuapp.com/${response.data.url}`
                : null
              : null;

            this.validade = response.data.data
              ? moment(response.data.data).isSameOrAfter(new Date())
                ? new Date(response.data.data)
                : new Date()
              : new Date();
          }
        });
    },
    redirecionar() {
      this.isLoading = true;
      localStorage.setItem("tipoid", "6");
      this.$router.push("/cadastrar-campanha");
      this.isLoading = false;
    },
    async save() {
      this.isLoading = true;
      var data = moment(this.validade).format("YYYY-MM-DD");
      var dataCompleta = moment(`${data} 23:59:59`).format();
      console.info({ dataCompleta });
      await axios
        .put(
          `${config.default.servidor}/gerencial/cardapio`,
          {
            empresaid: localStorage.getItem("enterprise_id").toString(),
            imagem: this.imageSource,
            datavalidade: dataCompleta
          },
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            let toast = this.$toasted.show("Sucesso!", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "check",
              iconPack: "fontawesome"
            });
          } else {
            let toast = this.$toasted.show("Algo deu errado.", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "times",
              iconPack: "fontawesome"
            });
          }
        })
        .catch(error => {
          let toast = this.$toasted.show("Algo deu errado.", {
            theme: "toasted-primary",
            position: "bottom-center",
            duration: 5000,
            icon: "times",
            iconPack: "fontawesome"
          });
        });
      this.isLoading = false;
      this.saveBtn = false;
    }
  }
};
</script>
